/** True when running inside the Tauri desktop shell. */
export const isDesktop = typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;

/**
 * Opens an external URL. In the desktop app links must go to the system browser, not the
 * app's own webview; the Tauri plugin is loaded lazily so the web bundle never pays for it.
 */
export async function openExternal(url: string): Promise<void> {
  if (!isDesktop) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  const { openUrl } = await import('@tauri-apps/plugin-opener');
  await openUrl(url);
}
